import React, { Component } from 'react';

class Icon extends Component{
    render(){
        var classes = 'icon icon-' + this.props.value + (typeof this.props.classes !== 'undefined' ? ' ' + this.props.classes : '');
        //var value = '<use xlink:href="#' + this.props.value + '-icon"></use>';
        var value = '#' + this.props.value + '-icon';
        return(
            <svg className={ classes }>
                <use xlinkHref={value}></use>
            </svg>
        );
    }
}
Icon.propTypes = {
    value: React.PropTypes.string.isRequired,
    classes: React.PropTypes.string
};
export default Icon;


/** WEBPACK FOOTER **
 ** ./src/components/Icon.js
 **/